import { io } from "socket.io-client";
import { useEffect, useRef } from "react";
import { logoutAndRedirect } from "./auth";
let socket = null;
export function getSocket() {
  
  const token = localStorage.getItem("auth_token");
  /* const socket = io("http://localhost:4000", {
    transports: ["websocket"],
    auth:{
      token:token,
    },
    autoConnect: true,
    reconnection: false,
  }); */
  //for server setup
  const socket = io("https://pos.bookyep.com", {
    transports: ["websocket"],
    auth:{
      token:token,
      autoConnect: true,
      reconnection: false,
    },
    secure: true,
    withCredentials: true
  });
  socket.on("connect_error", (err) => {
    console.log("Socket error:", err.message);

    if (err.message === "TOKEN_EXPIRED" || err.message === "INVALID_TOKEN" ||  err.message === "TOKEN_REQUIRED") {
      // AUTO LOGOUT
      logoutAndRedirect();
    }
  });
  return socket;
}

// export default socket;